import styled from "styled-components";

export const Container = styled.div`
    background-color: ${({ theme }) => theme.white};
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 16px;
    border-radius: 4px;
    width: 472px;
`;

export const Title = styled.h2`
    color: ${({ theme }) => theme.purple600};
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.07px;
`;

export const Description = styled.p`
    color: ${({ theme }) => theme.gray800};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.14px;
`;

export const Buttons = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 16px;

    button {
        &:first-child {
            max-width: 120px;
        }

        &:last-child {
            background-color: ${({ theme }) => theme.redError};
            max-width: 162px;
            border: none;
        }
    }
`;
